import { Select } from '@zorro/design-system/v2/Select';
import { FormErrorMessage, LabelWithTooltip } from '@zorro/web/design-system';
import {
  Control,
  FieldPath,
  FieldValues,
  useController,
} from 'react-hook-form';

import { getMonthlyAutoPayDateOptions } from './PaymentStatusUtils';

const MONTHLY_AUTO_PAY_DATE_DATA = getMonthlyAutoPayDateOptions();

type Props<TFieldValues extends FieldValues> = {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  isRequired?: boolean;
  isDisabled?: boolean;
};

// The "Monthly auto-pay date" selector, shared by the agent block and the
// employee self-service drawer so the field lives in one place.
export function MonthlyAutoPayDateInput<TFieldValues extends FieldValues>({
  control,
  name,
  isRequired,
  isDisabled,
}: Props<TFieldValues>) {
  const {
    field,
    formState: { errors },
  } = useController({ control, name });

  return (
    <>
      <Select
        label={
          <LabelWithTooltip
            label="Monthly auto-pay date"
            isRequired={isRequired}
            color="var(--color-text-default-secondary)"
          />
        }
        placeholder="Select monthly auto-pay date"
        data={MONTHLY_AUTO_PAY_DATE_DATA}
        value={(field.value as string | null) ?? null}
        onChange={(val) => field.onChange(val)}
        disabled={isDisabled}
      />
      <FormErrorMessage fieldName={name} errors={errors} />
    </>
  );
}
